import { Badge } from "antd";
import { NotificationOutlined } from "@ant-design/icons";
import { useContext, useState } from "react";
import { createPortal } from "react-dom";

import { NotificationsContext } from "@contexts/Notifications/context";
import { NotificationsPopover } from "./NotificationsPopover";

export function NotificationBell() {
  const { hasPending } = useContext(NotificationsContext);
  const [open, setOpen] = useState(false);

  return (
    <>
      <Badge dot={hasPending}>
        <NotificationOutlined
          style={{ fontSize: 20, cursor: "pointer", color: "#fff" }}
          onClick={() => setOpen((prev) => !prev)}
        />
      </Badge>

      {open &&
        createPortal(
          <NotificationsPopover onClose={() => setOpen(false)} />,
          document.body,
        )}
    </>
  );
}
